module.exports = __webpack_public_path__ + "img/FEMALE.2390448a.svg";